/**
 * Badge LONG / SHORT / FLAT pra Posicao Aberta (Task #80b).
 *
 * Direcao da exposicao baseada no sinal de volume_liquido (MWh):
 *   > 0  → LONG  (comprado, sobra a vender — verde, espelha pattern positivo)
 *   < 0  → SHORT (vendido, falta a comprar — vermelho)
 *   = 0  → FLAT  (sem exposicao residual — cinza, raro mas pra UI nao ter caso ausente)
 *
 * Pill compacto, fonte 9px uppercase, font-bold pra leitura rapida.
 * Cor casa com o numero ao lado (cascateada na td/div pai via inherit).
 */

export type DirecaoPosicao = "long" | "short" | "flat";

export function direcaoFromVolume(volumeMwh: string | number | null | undefined): DirecaoPosicao {
  if (volumeMwh === null || volumeMwh === undefined || volumeMwh === "") return "flat";
  const n = typeof volumeMwh === "string" ? Number(volumeMwh) : volumeMwh;
  if (!Number.isFinite(n) || n === 0) return "flat";
  return n > 0 ? "long" : "short";
}

const STYLES: Record<DirecaoPosicao, string> = {
  // Verde-claro / texto verde-escuro — matchea --indra-positivo do design system
  // sem importar o token diretamente (Tailwind ja resolve via classes).
  long: "bg-indra-positivo/15 text-indra-positivo border border-indra-positivo/30",
  short: "bg-indra-negativo/15 text-indra-negativo border border-indra-negativo/30",
  // FLAT raro — cinza neutro, nao polui na cor de texto cascateada da row.
  flat: "bg-white/10 text-white/60 border border-white/20",
};

const LABEL: Record<DirecaoPosicao, string> = {
  long: "LONG",
  short: "SHORT",
  flat: "FLAT",
};

interface Props {
  volumeMwh: string | number | null | undefined;
  /** Sufixo opcional pra encontrar o badge nos tests (`<root>-long` etc). */
  testIdPrefix?: string;
}

export function PosicaoBadge({ volumeMwh, testIdPrefix = "posicao-badge" }: Props) {
  const dir = direcaoFromVolume(volumeMwh);
  return (
    <span
      className={
        "inline-flex items-center rounded px-1.5 py-px text-[9px] font-bold uppercase tracking-wider " +
        STYLES[dir]
      }
      data-testid={`${testIdPrefix}-${dir}`}
    >
      {LABEL[dir]}
    </span>
  );
}
